import { Injectable, inject } from '@angular/core';
import { FileService } from './file.service';
import { jsonDeepClone } from './jsonDeepClone';
import { SiaNewRouterService } from './new-router.service';
import { notify } from './notify';
import { SiaParamsAndPatternsService } from './params-and-patterns.service';

@Injectable({
  providedIn: 'root',
})
export class ComponentService {
  private paramsAndPatternService = inject(SiaParamsAndPatternsService);
  private fileService = inject(FileService);
  private routerService = inject(SiaNewRouterService);

  async processAction(action: string, item: any) {
    var clickParams = action.split('|');
    if (!clickParams || clickParams.length == 0) return;
    var clickAction = clickParams.splice(0, 1);
    let guid = this.routerService.getLatestRoutingData()?.guid ?? '';
    switch (clickAction[0]) {
      case 'phone':
        var phoneValue = this.paramsAndPatternService.resolvePatternValue(
          clickParams[0],
          item,
          guid,
        );
        if (phoneValue) {
          var numb = phoneValue.match(/\d/g);
          numb = numb.join('');
          document.location.href = 'tel:' + numb;
        }
        break;
      case 'email':
        var email = this.paramsAndPatternService.resolvePatternValue(
          clickParams[0],
          item,
          guid,
        );
        if (email) {
          document.location.href = 'mailto:' + email;
        }
        break;
      case 'download':
        var path = this.paramsAndPatternService.resolvePatternValue(
          clickParams[0],
          item,
          guid,
          false,
        );
        try {
          await this.fileService.downloadFile(
            path,
            path.split('\\').pop() || 'download',
            true,
            false,
          );
        } catch (error) {
          console.error('Errore nel download del file:', error);
          notify('Errore nel download del file.', 2000, 'error');
          return;
        }
        break;
      case 'pdf-view':
        var path = this.paramsAndPatternService.resolvePatternValue(
          clickParams[0],
          item,
          guid,
        );
        this.routerService.navigateMenuWithParams('popup^pdf-viewer', [
          { id: 'path', value: path },
        ]);
        break;
      case 'map':
        let addressValue = this.paramsAndPatternService.resolvePatternValue(
          clickParams[0],
          item,
          guid,
        );
        if (addressValue) {
          window.open('http://maps.google.com/?q=' + addressValue + '"');
        }
        break;
      case 'mixed':
        var type = this.paramsAndPatternService.resolvePatternValue(
          clickParams[0],
          item,
          guid,
        );
        var value = this.paramsAndPatternService.resolvePatternValue(
          clickParams[1],
          item,
          guid,
        );
        if (!value) {
          return;
        }
        switch (type) {
          case 'phone':
          case 'mobile':
          case 'telephone':
            document.location.href = 'tel:' + value;
            break;
          case 'email':
            document.location.href = 'mailto:' + value;
            break;
          default:
            break;
        }
        break;
      case 'sql-editor':
        var componentId = this.paramsAndPatternService.resolvePatternValue(
          clickParams[0],
          item,
          guid,
        );
        this.routerService.navigateToSqlEditor(componentId);
        break;
      case 'navigate':
        var endRemove = action.indexOf('|');
        action = action.slice(endRemove + 1, action.length);
        endRemove = action.indexOf('|');
        var navigateMenu = jsonDeepClone(action);
        if (endRemove != -1) {
          navigateMenu = navigateMenu.slice(0, endRemove);
          action = action.slice(endRemove + 1, action.length);
        }

        var mode = 'read';
        var menuAndModes = navigateMenu.split('/');
        if (menuAndModes.length == 2) {
          navigateMenu = menuAndModes[0];
          mode = menuAndModes[1];
        }
        var navigateSiaSessionParams =
          this.paramsAndPatternService.resolveParamsPattern(action, item, guid);
        if (navigateMenu.indexOf('[') != -1) {
          let navigateMenuReplace = navigateMenu.substring(
            navigateMenu.indexOf('[') + 1,
            navigateMenu.lastIndexOf(']'),
          );
          let resolvedMenu = item[navigateMenuReplace];
          navigateMenu = navigateMenu.replace(
            '[' + navigateMenuReplace + ']',
            resolvedMenu,
          );
        }
        this.routerService.navigateMenuWithParams(
          navigateMenu,
          navigateSiaSessionParams,
          mode,
        );
        break;

      default:
        break;
    }
  }
}
